import { from, BehaviorSubject, ReplaySubject, fromEvent } from 'rxjs';
import { mergeMap, tap, filter, map } from 'rxjs/operators';

class FrameTransport {
  constructor(target, origin) {
    this.target = target;
    this.origin = origin;
    const sub1 = this.connected.pipe(
      mergeMap(
        (value) => value ? this.sends.pipe(tap((message) => this._send(message))) : from([])
      )
    ).subscribe();
    const sub2 = this._messages().subscribe((message) => {
      if (FrameTransportMessage.isConnect(message)) {
        this._send({
          type: "transport:connected"
        });
        return;
      }
      if (FrameTransportMessage.isConnected(message)) {
        if (!this._connected.getValue()) {
          this._send({
            type: "transport:connected"
          });
          this._connected.next(true);
        }
        return;
      }
    });
    this._subs.push(sub1, sub2);
  }
  _connected = new BehaviorSubject(false);
  sends = new ReplaySubject();
  _subs = [];
  _send(message) {
    this.target.postMessage(message, this.origin);
  }
  _messages() {
    return fromEvent(window, "message").pipe(
      filter((e) => {
        return this.origin === "*" || e.origin === this.origin;
      })
    ).pipe(map((e) => e.data));
  }
  messages() {
    return this._connected.pipe(
      mergeMap((value) => value ? this._messages() : from([]))
    );
  }
  open() {
    this._send({
      type: "transport:connect"
    });
  }
  send(message) {
    this.sends.next(message);
  }
  get connected() {
    return this._connected;
  }
  destroy() {
    this._subs.forEach((sub) => sub.unsubscribe());
    this.sends.complete();
    this._connected.complete();
  }
}
var FrameTransportMessage;
((FrameTransportMessage2) => {
  FrameTransportMessage2.isConnect = is("transport:connect");
  FrameTransportMessage2.isConnected = is("transport:connected");
})(FrameTransportMessage || (FrameTransportMessage = {}));
function is(t) {
  return (message) => typeof message === "object" && !!message && "type" in message && typeof message.type === "string" && message.type === t;
}

export { FrameTransport, FrameTransportMessage };
